import Vue from 'vue'

// Firebase
import firebaseConfig from '@/config/firebase'
import firebase       from 'firebase'
import 'firebase/auth';
import 'firebase/functions';
// import 'firebase.firestore'

const firebaseApp = firebase.initializeApp(firebaseConfig)
const db          = firebaseApp.firestore()

export const app       = firebase.app();
export const auth      = firebase.auth();
export const functions = firebase.functions();

Vue.$db = db

// https://fireship.io/snippets/sendgrid-vue/